import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { axiosPrivate } from '../api/axios';
import { CircularProgress, Box } from '@mui/material';
import NotAuthorized from '../components/Landing/NotAuthorized';

/**
 * 백엔드 API를 통해 현재 로그인한 유저가
 * 해당 그룹의 특정 프로젝트 시스템에 접근 권한이 있는지 검사합니다.
 * @param {string} systemType - 검사할 시스템 타입 (예: 'MASTER', 'DT', 'APS')
 */
const ProjectGuard = ({ children, systemType }) => {
  const { group_code, project_code } = useParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'authorized' | 'unauthorized' | 'error'

  useEffect(() => {
    // 파라미터가 없으면 검사할 수 없음 (라우트 설정 문제일 수 있음)
    // systemType이 없는 경우는 개발 단계에서 실수일 수 있으므로 콘솔 경고
    if (!group_code || !project_code) {
      setStatus('authorized'); 
      return;
    }

    if (!systemType) {
        console.warn("ProjectGuard: systemType prop is missing!");
        setStatus('authorized'); // 일단 통과시키지만 경고
        return;
    }

    const checkAuth = async () => {
      try {
        setStatus('loading');
        // axiosPrivate는 이미 baseURL과 interceptor(토큰 주입)가 설정되어 있음
        const response = await axiosPrivate.get(`/auth/checkUserAuth`, {
          params: { group_code, project_code, system_type: systemType },
        });

        if (response.data.isValid) {
          setStatus('authorized');
        } else {
          setStatus('unauthorized');
        }
      } catch (error) {
        console.error("ProjectGuard Check Failed:", error);
        // 403 Forbidden or 404 Not Found
        setStatus('unauthorized');
      }
    };

    checkAuth();
  }, [group_code, project_code, systemType]);

  if (status === 'loading') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: '#f5f5f5' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === 'unauthorized') {
    return <NotAuthorized intendedGroupCode={group_code} />;
  }

  // authorized
  return children;
};

export default ProjectGuard;
